<div class="content__inner">
    <header class="content__title">
        <h1>{{ "abousers.list.title" | translate }}</h1>
        <small>{{ "abousers.list.subtitle" | translate }}</small>
    </header>

    <div class="card" *appHasPermission="'ABOUSERS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "abousers.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "abousers.props.email" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
                    </ng-container>

                    <ng-container matColumnDef="firstname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "abousers.props.firstname" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.firstname }}</td>
                    </ng-container>

                    <ng-container matColumnDef="lastname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "abousers.props.lastname" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.lastname }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "abousers.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "abousers.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <i (click)="viewAboUser(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'ABOUSERS.VIEW'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
